module.exports = {"magic":"","disease":"","poison":"","curse":"","enrage":"","none":"","n_a":"","unknown":""};